// [TR-2087] - Used a forEach for all the below to catch any missing data that may be in normalisedRelationships but missing from normalisedData

const cropsTransformer = (media: { url: string; width: number }[]) =>
  media.map((url) => ({
    src: url.url,
    width: url.width,
  }))

const surchargeTransformer = (surcharge: { price: { value: number } } | null) => {
  if (!surcharge) return null
  const decimalSurcharge = surcharge.price.value / 100

  return {
    listPrice: decimalSurcharge,
  }
}

const isFineDineInTransformer = (attributes: { food_brand: { slug: string } | null }) =>
  Boolean(attributes.food_brand && attributes.food_brand.slug === 'fine-dine-in')

const isNewTransformer = (
  debutRecipes: { data: { core_recipe_id: string }[] },
  recipeId: string,
) => {
  if (debutRecipes && debutRecipes.data && debutRecipes.data.length) {
    return debutRecipes.data.some((recipe) => recipe.core_recipe_id === recipeId)
  }

  return false
}

export { cropsTransformer, surchargeTransformer, isFineDineInTransformer, isNewTransformer }
